/* eslint-disable arrow-body-style */
import { useMemo, useState } from 'react';
import { useShallow } from 'zustand/shallow';
import Text from '../../../../assets/styles/Text';
import Loader from '../../../../components/Loader';
import PopUpSearch from '../../../../components/PopUpSearch';
import PriceRangeFilter from '../../../../components/PriceRangeFilter';
import { useFiltersByGenderFilter } from '../../../../hooks/queries/useFilters';
import { useStore } from '../../../../stores';
import { GENDERS } from '../../../../utils/genders';
import * as styles from './styles';

export default function Filter() {
  const [activeGender, setActiveGender] = useState('WOMAN');
  const [showSearch, setShowSearch] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const { filtersSelect, addFilter, removeFilter, clearFilters } = useStore(
    useShallow((state) => ({
      filtersSelect: state.filtersSelect,
      addFilter: state.addFilter,
      removeFilter: state.removeFilter,
      clearFilters: state.clearFilters,
    }))
  );

  // Get value genders
  const currentGenderValue = useMemo(() => {
    return GENDERS.find((g) => g.key === activeGender)?.value;
  }, [activeGender]);

  const {
    data: filters,
    isLoading,
    isError,
    error,
  } = useFiltersByGenderFilter(currentGenderValue, isExpanded);

  // To Change filters
  function handleShowFilter(genderKey) {
    setActiveGender(genderKey);
    clearFilters();
  }

  // Allocate choices to options
  function parseChoices(choicesString) {
    return choicesString
      .split(',')
      .map((choice) => choice.trim())
      .filter(Boolean);
  }

  // Handler filters select toggle
  function handleToggleFilter(filterId, choice, isMultiple) {
    const filterKey = `${filterId}-${choice}`;
    const isActive = filtersSelect.includes(filterKey);

    // No multiple = remove others filters
    if (!isMultiple) {
      const currentFiltersOfSameType = filtersSelect.filter((item) =>
        item.startsWith(`${filterId}-`)
      );

      currentFiltersOfSameType.forEach((item) => {
        if (item !== filterKey) {
          removeFilter(item); // Remove filters different
        }
      });
    }

    // Toggle: active = remove || no active = add
    if (isActive) {
      removeFilter(filterKey);
    } else {
      addFilter(filterKey);
    }
  }

  // Filters this active
  function isFilterActive(filterId, choice) {
    return filtersSelect.includes(`${filterId}-${choice}`);
  }

  function renderFilterColumn(columnFilters) {
    return columnFilters.map((filter) => {
      const choices = parseChoices(filter.choices);
      const isMultiple = filter.multiple;

      return (
        <styles.FilterGroup key={filter.id}>
          <Text.P>{filter.name}</Text.P>
          <styles.ButtonGroup $wrap={choices.length > 2}>
            {choices.map((choice) => {
              const isActive = isFilterActive(filter.id, choice);

              return (
                <styles.FilterButton
                  key={choice}
                  $isActive={isActive}
                  onClick={() =>
                    handleToggleFilter(filter.id, choice, isMultiple)
                  }
                  type="button"
                >
                  <Text.P>{choice}</Text.P>
                </styles.FilterButton>
              );
            })}
          </styles.ButtonGroup>
        </styles.FilterGroup>
      );
    });
  }

  return (
    <styles.Container>
      <styles.GroupTitle
        onClick={() => setIsExpanded((prev) => !prev)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
      >
        <Text.H1>FILTROS DE BUSCA</Text.H1>
        <styles.ArrowIcon $isExpanded={isExpanded} />
      </styles.GroupTitle>

      {isExpanded && (
        <>
          <styles.GroupButton>
            {GENDERS.map(({ key, label }) => (
              <styles.Button
                key={key}
                type="button"
                onClick={() => handleShowFilter(key)}
                $isActive={activeGender === key}
                disabled={isLoading}
              >
                <Text.H4>{label}</Text.H4>
              </styles.Button>
            ))}
          </styles.GroupButton>

          <styles.FilterBody>
        {isError && (
          <Text.Span>{error?.message || 'Erro ao carregar filtros'}</Text.Span>
        )}

        {isLoading && <Loader isLoading minimal />}

        {!isLoading && filters && (
          <>
            <PriceRangeFilter />

            <styles.Row>
              <styles.Column>
                {renderFilterColumn(filters.leftColumn)}
              </styles.Column>

              <styles.VerticalDivider />

              <styles.Column>
                {renderFilterColumn(filters.rightColumn)}
              </styles.Column>
            </styles.Row>

            <styles.Button
              type="button"
              className="button"
              onClick={() => setShowSearch(true)}
              aria-label="Pesquisar por cidade"
            >
              <Text.P $upper>Pesquisar</Text.P>
            </styles.Button>
          </>
        )}
          </styles.FilterBody>
        </>
      )}

      <PopUpSearch
        show={showSearch}
        onHideWindow={() => setShowSearch(false)}
      />
    </styles.Container>
  );
}
